import { cn } from 'lib/helpers/utility';

import DocText from '../DocText';
import { DOC_GAPS, DOC_TEXT } from '../lib/docStyles';

const DocSectionHead = ({ title, className }) => (
  <DocText
    variant="label"
    size="small"
    className={cn(DOC_TEXT.sectionHead, DOC_GAPS.heading, className)}>
    {String(title ?? '').toUpperCase()}
  </DocText>
);

export default DocSectionHead;
